<template>

</template>

<script>
export default {
name: "MinxinScroll",
  data(){
  return {
    /*使用手册
    * 1，在组件中引入minxins
    * 2，el-table增加ref="table"
    * 3, 当前组件添加到keep-alive的include数组中
    * 4, 解决分页切换的时候恢复scrollTop的位置
    *    注：在切换分页的函数handlePageNumChange中添加：
    *    this.scrollTop = 0
    *    this.saveScroll()
    * 以上就是该混入的使用方法
    * */
    scrolltop: null
   }
  },
  mounted() {
    this.addEventScroll()
  },
  activated() {
    this.saveScroll()
    this.getData()
  },
  beforeDestroy() {
    this.cancelScroll();
  },
  methods:{
    //添加监听滚动
    addEventScroll(){
      // 监听滚动条的位置
      this.$refs.table.bodyWrapper.addEventListener('scroll', (res) => {
        let height = res.target
        this.scrollTop = height.scrollTop
      },false)
    },
    //取消监听滚动
    cancelScroll(){
      this.$refs.table.bodyWrapper.removeEventListener('scroll', (res) => {
        let height = res.target
        this.scrollTop = height.scrollTop
      },false)
    },
    // 这里如果直接赋值给this.$el.querySelector('.el-table__body-wrapper').scrollTop会失效，需要加上setTimeout才行。
    saveScroll() {
      this.$nextTick(()=> {
        setTimeout(() => {
          var scrollTop = this.$el.querySelector('.el-table__body-wrapper')
          scrollTop.scrollTop = this.scrollTop
        }, 13)
      })
    },
  }
}
</script>

<style scoped>

</style>
